import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, ChevronDown, AlertCircle } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export const TopBar = () => {
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show only when at the very top (within 10px)
      if (currentScrollY < 10) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('lumon-lang', langCode);
  };

  const getDisclaimerText = () => {
    switch(i18n.language) {
      case 'es':
        return 'Solo para fines educativos y de investigación.';
      case 'pt':
        return 'Apenas para fins educacionais e de pesquisa.';
      default:
        return 'For educational and research purposes only.';
    }
  };

  return (
    <div 
      className={`
        w-full bg-[#4d82a9] text-white py-2 px-4 
        transition-all duration-300 ease-in-out
        ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0 pointer-events-none'}
      `}
      style={{ position: 'sticky', top: 0, zIndex: 60 }}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
        {/* Disclaimer */}
        <div className="flex items-center gap-2">
          <AlertCircle className="w-4 h-4 flex-shrink-0 opacity-80" />
          <span className="text-xs sm:text-sm opacity-90">
            {getDisclaimerText()}
          </span>
        </div>
        
        {/* Language Selector */}
        <div className="flex items-center gap-1">
          <Globe className="w-4 h-4 opacity-80" />
          <div className="flex items-center gap-1">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`
                  px-2 py-1 rounded text-xs font-medium transition-all
                  ${i18n.language === lang.code 
                    ? "bg-white/20 text-white" 
                    : "text-white/70 hover:text-white hover:bg-white/10"
                  }
                `}
              >
                <span className="mr-1">{lang.flag}</span>
                {lang.shortName}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
